@let user = userSignal();

<a class="session-dropdown-trigger" nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
  @if (user?.firstName) {
    <nz-avatar class="session-avatar" [nzText]="(user?.firstName)![0] | uppercase"></nz-avatar>
  } @else {
    <nz-avatar nzIcon="user"></nz-avatar>
  }

  <span class="session-dropdown-trigger__identity">
    <span class="session-dropdown-trigger__name">{{ user?.fullName! || user?.email }}</span>
    @if (userRoleLabel()) {
      <span
        class="session-dropdown-trigger__role"
        [class.session-dropdown-trigger__role--admin]="userRoleKind() === 'admin'"
        [class.session-dropdown-trigger__role--supplier]="userRoleKind() === 'supplier'"
        [class.session-dropdown-trigger__role--installer]="userRoleKind() === 'installer'"
      >
        {{ userRoleLabel() }}
      </span>
    }
  </span>
  <i nz-icon nzType="down"></i>
</a>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu [nzSelectable]="false">
    <li nz-menu-item nzMatchRouter [nzMatchRouterExact]="false" [routerLink]="shellRoutes.PERSONAL">Настройки учётной записи</li>
    <li nz-menu-item (click)="logout()">Выйти из учётной записи</li>
  </ul>
</nz-dropdown-menu>
